module.exports = __webpack_public_path__ + "media/images/background_dark-9e39e7beff8af8f1d3f0efadd2b30a7f.png";